import React from "react";

const CoinValue = ({ coinValue, setCoinValue }) => {
  return (
    <div className="mt-8 p-4 border rounded-md bg-blue-50 shadow-lg">
      <h3 className="text-lg font-semibold mb-4">Coin Value</h3>
      <div className="relative">
        <input
          type="text"
          inputMode="numeric"
          pattern="[0-9]*"
          value={coinValue}
          onChange={(e) => setCoinValue(e.target.value.replace(/[^0-9]/g, ""))}
          onKeyDown={(e) => {
            if (!/^\d$/.test(e.key) && !["Backspace","Delete","ArrowLeft","ArrowRight","Tab","Enter","Home","End"].includes(e.key) && !e.ctrlKey && !e.metaKey) e.preventDefault();
          }}
          onFocus={(e) => e.target.select()}
          className="w-full lg:w-1/2 border rounded-md px-4 py-2"
        />
        <label className="absolute text-sm text-blue-500 bg-white px-1 left-3 -top-2 transition-all">
          Coin Value = ₹{coinValue}
        </label>
      </div>
    </div>
  );
};

export default CoinValue;
